import React, { useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import {
  isMobile,
  freeBetStore,
  RightContainer,
  useTranslation,
  gameConfigStore,
  BetResponseCode,
  notificationStore,
} from '@pascal/pascal-core';

import { roundsInfoStore } from '../../../store';
import { LiveBetsWrapper } from '../liveBetsWrapper';
import { globalTranslationKeys } from '../../../enums';
import { BetHistoryWrapper } from '../betHistoryWrapper';
import { GameResultsWrapper } from '../gameResultsWrapper';

const RightColumn = observer(() => {
  const { lastWinBets } = roundsInfoStore;
  const { limits } = gameConfigStore;

  const { LiveBets, History, Results } = globalTranslationKeys;

  const t = useTranslation();

  const rightContainerTabs = useMemo(
    () => [
      { name: t(LiveBets) },
      { name: t(History), isBetHistory: true },
      ...(isMobile() ? [] : [{ name: t(Results) }]),
    ],
    []
  );

  const rightContainerTabsContainers = useMemo(
    () => [<LiveBetsWrapper />, <BetHistoryWrapper />, ...(isMobile() ? [] : [<GameResultsWrapper />])],
    []
  );

  useEffect(() => {
    if (lastWinBets.length) {
      lastWinBets.forEach((item) => {
        const winBetData = item.additionalParams.markets.find((el) => el.winAmount);
        if (item.freeBetId) {
          if (!freeBetStore.freeBets.find((freeBet) => freeBet.id === item.freeBetId)) {
            return;
          }
          const freeBetMaxPayout = freeBetStore.freeBets.find((freeBet) => freeBet.id === item.freeBetId).maxPayout;
          if (winBetData?.amount * winBetData?.odd > freeBetMaxPayout && winBetData) {
            // setTimeout(
            //   () => notificationStore.setNotificationType({ responseCode: BetResponseCode.FreeBetMaxWinPayout }),
            //   3800
            // );
          }
        } else {
          if (winBetData?.amount * winBetData?.odd > limits.maxWin && winBetData) {
            setTimeout(
              () => notificationStore.setNotificationType({ responseCode: BetResponseCode.MaxWinLimitNote }),
              3800
            );
          }
        }
      });
    }
  }, [lastWinBets, limits]);

  return (
    <RightContainer
      hasFreeBets
      setWinColor
      haveDarkMode
      tabs={rightContainerTabs}
      tabContainers={rightContainerTabsContainers}
    />
  );
});

export default RightColumn;
